export const bradNav = [
  {
    id: -1,
    label: "首页",
    url: `/home`,
    order: 0
  },
  {
    id: 0,
    label: "灌溉决策",
    url: `https://nmgnq.cn/decisionsys/irrigation`,
    order: 0
  },
  {
    id: 6,
    label: "气候区划",
    items: [
      {
        id: 1,
        label: "气候资源区划"
      },
      {
        id: 2,
        label: "农牧业适宜性区划"
      },
      {
        id: 3,
        label: "灾害风险区划"
      }
    ],
    order: 1
  },
  {
    id: 7,
    label: "农情资讯",
    order: 1
  },
  {
    id: 8,
    label: "生产百科",
    items: [
      {
        id: 1,
        label: "农业百科"
      },
      {
        id: 2,
        label: "林业百科"
      },
      {
        id: 3,
        label: "畜牧百科"
      }
    ],
    order: 1
  },
  {
    id: 9,
    label: "预警详情",
    hiden: true,
    order: 1
  },
  {
    id: 10,
    label: "农业天气通",
    hiden: true,
    order: 1
  },
  {
    id: 11,
    label: "农情调查",
    order: 1
  }
];

export const market = [
  { code: 1501001, label: "东瓦窑市场" },
  { code: 1501005, label: "呼市惠东" },
  { code: 1501007, label: "内蒙古美通" },
  { code: 1501009, label: "呼市馨方园" },
  { code: 1502003, label: "包头市友谊" },
  { code: 1502006, label: "包头裕丰" },
  { code: 1504002, label: "赤峰西城" },
  { code: 1505004, label: "通辽余粮堡" },
  { code: 1505018, label: "丰盛农产品物流园" },
  { code: 1506012, label: "内蒙古富兴" },
  { code: 1506016, label: "蒙三段地" },
  { code: 1506019, label: "万家惠市场" },
  { code: 1507011, label: "满州里五兴" },
  { code: 1507017, label: "海拉尔新桥" },
  { code: 1526010, label: "蒙察右中旗" },
  { code: 1526014, label: "蒙兴和北兴" },
  { code: 1526015, label: "蒙四子王旗" },
  { code: 1528008, label: "蒙临河蔬菜" },
  { code: 1528013, label: "鸿鼎市场" }
];
export const factors = [
  {
    id: 1,
    label: "气温",
    factor: 1,
    key: 1,
    unit: "℃"
  },
  {
    id: 2,
    label: "气压",
    factor: 2,
    key: 1,
    unit: "hPa"
  },
  {
    id: 3,
    label: "相对湿度",
    factor: 18,
    key: 1,
    unit: "%"
  },
  {
    id: 4,
    label: "降水量",
    factor: 5,
    key: 1,
    unit: "mm"
  },
  {
    id: 5,
    label: "风力",
    factor: 4,
    key: 1,
    unit: "级"
  }
];

export const meteoFactorList = [
  { id: 1, label: "温度", unit: "℃", key: "tem", color: "#ff7916" },
  { id: 5, label: "风力", unit: "级", key: "win_s_max", color: "#5c72f7" },
  { id: 2, label: "气压", unit: "hPa", key: "prs", color: "#0ecbb2" },
  { id: 3, label: "相对湿度", unit: "%", key: "rhu", color: "#008aff" },
  { id: 4, label: "降水量", unit: "mm", key: "pre", color: "#2fcbe2" }
];

export const windyDirection = {
  N: { value: 0, offset: [0, "-50%"] },
  NW: { value: 45, offset: ["-50%", "-50%"] },
  W: { value: 90, offset: ["-75%", "-10%"] },
  SW: { value: 135, offset: ["-75%", "50%"] },
  S: { value: 180, offset: [0, "50%"] },
  SE: { value: 225, offset: ["50%", "50%"] },
  E: { value: 270, offset: ["85%", "10%"] },
  NE: { value: 315, offset: ["85%", "-50%"] }
};
export const windyDirLabel = {
  0: "北风",
  45: "西北风",
  90: "西风",
  135: "西南风",
  180: "南风",
  225: "东南风",
  270: "东风",
  315: "东北风"
};

export const EVENT_TYPE_MAP = {
  "1001": {
    Blue: "1001_Blue",
    Orange: "1001_Orange",
    Red: "1001_Red",
    Yellow: "1001_Yellow"
  },
  "1003": {
    Blue: "1003_Blue",
    Orange: "1003_Orange",
    Red: "1003_Red",
    Yellow: "1003_Yellow"
  },
  "1004": {
    Blue: "1004_Blue",
    Orange: "1004_Orange",
    Red: "1004_Red",
    Yellow: "1004_Yellow"
  },
  "1005": {
    Blue: "1005_Blue",
    Orange: "1005_Orange",
    Red: "1005_Red",
    Yellow: "1005_Yellow"
  },
  "1006": {
    Blue: "1006_Blue",
    Orange: "1006_Orange",
    Red: "1006_Red",
    Yellow: "1006_Yellow"
  },
  "1007": { Orange: "1007_Orange", Red: "1007_Red", Yellow: "1007_Yellow" },
  "1009": { Orange: "1009_Orange", Red: "1009_Red", Yellow: "1009_Yellow" },
  "1014": { Orange: "1014_Orange", Red: "1014_Red", Yellow: "1014_Yellow" },
  "1015": { Orange: "1015_Orange", Red: "1015_Red" },
  "1016": {
    Blue: "1016_Blue",
    Orange: "1016_Orange",
    Yellow: "1016_Yellow"
  },
  "1017": {
    Blue: "1017_Blue",
    Orange: "1017_Orange",
    Red: "1017_Red",
    Yellow: "1017_Yellow"
  },
  "1019": { Orange: "1019_Orange", Yellow: "1019_Yellow" },
  "1020": { Yellow: "1020_Yellow" },
  "1021": { Orange: "1021_Orange", Red: "1021_Red" },
  "1022": { Orange: "1022_Orange", Red: "1022_Red" },
  adefault: {
    Blue: "adefault_Blue",
    Orange: "adefault_Orange",
    Red: "adefault_Red",
    unknown: "adefault_Unknown",
    Yellow: "adefault_Yellow"
  }
};



// WEBPACK FOOTER //
// ./src/Constant.js